// src/components/objects/RotatingTorus.tsx
import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const RotatingTorus: React.FC = () => {
    const meshRef = useRef<THREE.Mesh>(null!);

    useFrame((_, delta) => {
        meshRef.current.rotation.x += delta * 0.2;
        meshRef.current.rotation.y += delta * 0.3;
    });

    return (
        <mesh ref={meshRef} position={[0, 0, -2]}>
            <torusGeometry args={[3, 0.4, 64, 128]} />
            <meshStandardMaterial
                color="#00ffff"
                metalness={0.5}
                roughness={0.3}
                emissive="#00ffff"
                emissiveIntensity={0.6}
            />
        </mesh>
    );
};

export default RotatingTorus;